// extracted by mini-css-extract-plugin
module.exports = {"card_main_div1":"LoyaltyTiers_card_main_div1__3HGWF","top_line":"LoyaltyTiers_top_line__2anuV"};